import { Modal } from "antd";
import CustomerLink from "../../shared/CustomerLink";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { useMutation, useQueryClient } from "react-query";
import { processGiftCard } from "../../../api/trade";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const GiftCardRequestDetail = ({ record, open, setOpen, setOpenModal, setRecordId }) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(processGiftCard, {
      onSuccess: () => {
        queryClient.invalidateQueries("gift-card-request");
        queryClient.invalidateQueries("gift-card-history");
        showSuccessToast("Action successful");
        setOpen(false);
      },
      onError: (e) => {
        showErrorToast(e.message);
      },
    });
  return (
    <Modal title="" open={open} footer={null} onCancel={() => setOpen(false)}>
      <h2 className="font-bold text-[20px] text-center line-[32px]">
        Request details
      </h2>
      <div className="flex justify-center items-center">
        <IoChevronBackCircleSharp color="green" size={25} />
      </div>
      <p className="text-[18px] text-center font-[500]">
        Requested USD {record?.amount} {record?.receiptType}
      </p>
      <p className="text-[12px] text-center text-[#787389]">
        {new Date(record.createdAt).toLocaleDateString()}{" "}{new Date(record.createdAt).toLocaleTimeString()}
      </p>

      <div className="flex justify-between mt-5">
        <p>Customer</p>
        <CustomerLink record={record} />
      </div>

      <div className="flex justify-between mt-2 mb-2">
        <p>Status</p>
        <p
          className={`capitalize ${
            (record.status === "pending" || record.status === "processing") ? "text-yellow-500" : record.status === "declined" ? "text-red-600" : "text-green-700"
          }`}
        >
          {record.status}
        </p>
      </div>
      <div className="bg-[#F1F0F0] p-2 flex justify-between rounded-sm">
        <p>Update status</p>
        <div className="flex gap-5">
          <div 
          onClick={() => mutation.mutate({ id: record._id, status: "completed" })}
          className={`bg-[#27AE60] text-white rounded-[5px] p-[5px] cursor-pointer`}>
            {mutation.isLoading ? "Updating record" : "Successful"}
          </div>
          <div 
          onClick={() => {
            setRecordId(record._id)
            setOpenModal(true);
            setOpen(false);
          }}
          className={`bg-[#E9E9E9] rounded-[5px] p-[5px] cursor-pointer`}>
            Decline
          </div>
        </div>
      </div>

      <hr />

      <div className="flex justify-between mt-5">
        <p>Quantity</p>
        <p>{record?.quantity}</p>
      </div>

      <div className="flex justify-between mt-2">
        <p>Country</p>
        <p className="capitalize">{record?.country}</p>
      </div>

      <div className="flex justify-between mt-2">
        <p>Category</p>
        <p>{record?.category}</p>
      </div>
      <div className="flex justify-between mt-2">
        <p>Transaction feed</p>
        <p>${Number(record?.amount).toLocaleString()}</p>
      </div>
      <div className="flex justify-between mt-2">
        <p>Payout</p>
        <p>₦{Number(record?.totalAmountInNaira).toLocaleString()}</p>
      </div>
      <div className="flex justify-between mt-2">
        <p>Payment method</p>
        <p>{record?.paymentMethod || "Wallet"}</p>
      </div>
      <div className="flex justify-between mt-2">
        <p>Order ID</p>
        <p>{record?._id}</p>
      </div>
      
      {record?.imageURL && (
        <div className="flex justify-between mt-2">
          <p>Card</p>
          <img
            src={record.imageURL}
            className="h-[150px] w-[150px]"
            alt="car"
          />
        </div>
      )}
      {record?.note && (
        <div className="flex justify-between mt-2">
          <p>Note</p>
          <p>{record.note}</p>
        </div>
      )}
      {record?.reason && (
        <div className="flex justify-between mt-2">
          <p>Declined Reason</p>
          <p>{record.reason}</p>
        </div>
      )}
    </Modal>
  );
};

export default GiftCardRequestDetail;
